<template>
  <div class="field-item">
    <div class="field-label">
      {{ field.label }}<i v-if="field.fill_status" class="impor">*</i>
    </div>
    <div class="field-control">
      <el-radio-group :value="value" @input="$emit('input', $event)">
        <el-radio v-for="(opt, i) in options" :key="i" :label="opt">{{ opt }}</el-radio>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FieldRadio',
  props: { field: Object, value: { default: '' } },
  computed: { options () { return this.field.data || [] } }
}
</script>
